/**
 * 会议管理 - 会议创建
 *
 * @file create.js
 * @author yangwei(yangwei14@baidu.com)
 */

import {Component} from 'san';
import {html} from '../common/raw';

export default class extends Component {
    static filters = {
        slice: name => {
            name.includes('@') && (name = name.split('@')[0]);
            return name && name.length < 10 ? name : name.slice && `${name.slice(0, 10)}..`;
        },
        count: num => {
            return `等${num}个`;
        }
    }
    static template = html`
    <template>
        <div
            s-if="partaner.length < 6"
            class="room-partner"
            s-for="partner in row.room_partner"
            title="{{partaner.email || partner.username}}">
            {{partner.username | slice}}
        </div>
        <div s-else>
            <span
                s-for="partner,idx in row.room_partner"
                title="{{partaner.email || partner.username}}">
                <span s-if="idx < 2" class="room-partner" title="{{partner.email}}">
                    {{partner.username | slice}}
                </span>
            </span>
            <span title="{{row.room_partner | getTips}}" class="more-partner">
                ...{{row.room_partner.length | count}}
            </span>
        </div>
    </template>
    `;
}
